import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcDestinations = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.25 19.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 1.75a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.5 6.25a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm-1.75 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.375 4.5a.875.875 0 0 1-.875.875h-.888l2.292 2.292a5.875 5.875 0 0 1 1.72 4.154v1.18h-1.75v-1.18a4.125 4.125 0 0 0-1.207-2.917l-2.292-2.291V7.5a.875.875 0 0 1-1.75 0v-3c0-.483.392-.875.875-.875h3c.483 0 .875.392.875.875Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "17.75",
  cy: "17.75",
  fill: "var(--mds-nav-icon-accent)",
  r: "3.25"
})), "IcDestinations");

export { IcDestinations };
//# sourceMappingURL=ic-destinations.js.map
